import type React from 'react';

import { ToastProvider } from '#src/app/shared/toast';

import { BannerSection } from '../components/BannerSection';
import { Details } from '../components/Details';

import { useShowSurvey } from './hooks/useShowSurvey';
import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	useShowSurvey();

	return (
		<ToastProvider>
			<BannerSection />
			<Details />
		</ToastProvider>
	);
};
